import React from 'react'
import { connect } from 'react-redux'
import MainLayout from './MainLayout'

export class CoreLayout extends React.Component {	

	render () {
	  return (
      <div>
        {this.props.isAuthenticated ? <MainLayout children={this.props.children} /> : ''}
      </div>);
	}
	
}

const mapStateToProps = (state) => ({
  isAuthenticating   : state.auth.isAuthenticating,
  isAuthenticated   : state.auth.isAuthenticated
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(CoreLayout);



/** WEBPACK FOOTER **
 ** ./js/layouts/CoreLayout.js
 **/